import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export const RootContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  padding: 2,
  maxWidth: '600px',
  width: '100%',
});

export const FilterButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: 6,
  padding: '10px 24px',
  marginLeft: '16px',
  borderColor: '#446889',
  color: '#446889',
  fontWeight: '600',
  fontSize: '1rem',
  '&:hover': {
    backgroundColor: '#446889',
    color: theme.palette.global.white,
  },
}));
